import React from 'react'

const CardsSVG = () => {
  return (
    React.createElement('svg', { width: "24", height: "24", viewBox: "0 0 22 20"   , fill: "none", xmlns: "http://www.w3.org/2000/svg",}
      , React.createElement('path', {
        d: "M20.4698 2.35L19.1298 1.79V10.82L21.5598 4.96C21.9698 3.94 21.4998 2.77 20.4698 2.35ZM0.969765 6.05L5.92976 18C6.23976 18.77 6.96976 19.24 7.73976 19.26C7.99976 19.26 8.26976 19.21 8.52976 19.1L15.8998 16.05C16.6498 15.74 17.1098 15 17.1298 14.26C17.1398 14 17.0898 13.71 16.9998 13.45L11.9998 1.5C11.7098 0.73 10.9698 0.26 10.1898 0.25C9.92976 0.25 9.66976 0.31 9.41976 0.4L2.05976 3.45C1.03976 3.87 0.549765 5.04 0.969765 6.05ZM17.1198 2.25C17.1198 1.71957 16.9091 1.21086 16.534 0.835786C16.1589 0.460714 15.6502 0.25 15.1198 0.25H13.6698L17.1198 8.59"                                                            ,
        fill: "#82809A",}
      )
    )
  )
}

export default CardsSVG
